const rootActionPath = 'core/similarStores';

export const SIMILAR_STORES_VIEW = `${rootActionPath}/VIEW`;
